// ─── Brand Colors ───
export const C = {
  green: "#2e8b57",
  greenDark: "#1a6b3c",
  greenDeep: "#0d4a28",
  greenLight: "#3ca86e",
  greenPale: "#e8f5ee",
  greenMist: "#f0faf4",
  gold: "#e8a838",
  goldDark: "#c48820",
  coral: "#e85d4a",
  purple: "#7c5cbf",
  navy: "#1a2332",
  navyLight: "#243044",
  white: "#fff",
  offWhite: "#fafcfb",
  gray100: "#f3f6f4",
  gray300: "#c8d5cd",
  gray500: "#6b8074",
  gray700: "#3a4f42",
  gray900: "#1c2b22",
};

// ─── Admin Credentials ───
export const ADMIN_EMAIL = "admin@smartway.com";
export const ADMIN_PASS = "admin123";

// ─── Products for Rewards Store ───
export const PRODUCTS = [
  { id: "p1", name: "3Doodler 3D Pen Set", points: 118, emoji: "🖊️", cat: "STEM" },
  { id: "p2", name: "Solar Car Building Kit", points: 72, emoji: "🚗", cat: "STEM" },
  { id: "p3", name: "Magic Chemistry Set", points: 72, emoji: "🧪", cat: "Science" },
  { id: "p4", name: "Gemstone Dig Kit", points: 80, emoji: "💎", cat: "Science" },
  { id: "p5", name: "LCD Writing Tablet", points: 20, emoji: "📝", cat: "Tech" },
  { id: "p6", name: "Dual Brush Pen Markers", points: 90, emoji: "🎨", cat: "Art" },
  { id: "p7", name: "World Globe with Stand", points: 250, emoji: "🌍", cat: "Education" },
  { id: "p8", name: "Cute School Supplies", points: 50, emoji: "✏️", cat: "Supplies" },
  { id: "p9", name: "Mr. Pen Erasers 6-Pack", points: 15, emoji: "🧹", cat: "Supplies" },
  { id: "p10", name: "Glow Stars for Ceiling", points: 35, emoji: "⭐", cat: "Decor" },
  { id: "p11", name: "Duck Night Light", points: 35, emoji: "🦆", cat: "Decor" },
  { id: "p12", name: "Shark Blanket Hoodie", points: 49, emoji: "🦈", cat: "Fun" },
  { id: "p13", name: "Piggy Bank ATM", points: 50, emoji: "🐷", cat: "Fun" },
  { id: "p14", name: "Unicorn Terrarium Kit", points: 55, emoji: "🦄", cat: "STEM" },
  { id: "p15", name: "Magic 8 Ball", points: 24, emoji: "🎱", cat: "Fun" },
  { id: "p16", name: "How To Draw Book", points: 40, emoji: "📖", cat: "Art" },
];

// ─── Programs / Courses ───
export const PROGRAMS = [
  { id: "shsat-group", name: "SHSAT Group (7th Grade)", schedule: "Sun 10:30AM–12:30PM", price: "$390/mo", cat: "Test Prep" },
  { id: "shsat-1on1", name: "SHSAT One-on-One", schedule: "Flexible", price: "Contact Us", cat: "Test Prep" },
  { id: "sat-prep", name: "SAT Prep (Math + ELA)", schedule: "Sun 6–8PM + Wed 8–9PM", price: "$390/mo", cat: "Test Prep" },
  { id: "focus-4wk", name: "FOCUS Program (4 Weeks)", schedule: "Multiple groups available", price: "$375", cat: "FOCUS" },
  { id: "focus-8wk", name: "FOCUS Program (8 Weeks)", schedule: "Multiple groups available", price: "$655", cat: "FOCUS" },
  { id: "math-elem", name: "Math Tutoring (Grades 1–5)", schedule: "Flexible", price: "Contact Us", cat: "Elementary" },
  { id: "ela-elem", name: "ELA / Reading (Grades 1–5)", schedule: "Flexible", price: "Contact Us", cat: "Elementary" },
  { id: "alg1-reg", name: "Algebra 1 Regents Group", schedule: "Flexible", price: "Contact Us", cat: "Middle School" },
  { id: "geo-reg", name: "Geometry Regents Group", schedule: "Flexible", price: "Contact Us", cat: "Middle School" },
  { id: "alg2", name: "Algebra 2 Tutoring", schedule: "Flexible", price: "Contact Us", cat: "High School" },
  { id: "bio", name: "Biology Tutoring", schedule: "Flexible", price: "Contact Us", cat: "High School" },
  { id: "special-90", name: "Special Ed — FOCUS Lab (90 min)", schedule: "Flexible", price: "$150/session", cat: "Special Ed" },
  { id: "special-60", name: "Special Ed — FOCUS Lab (60 min)", schedule: "Flexible", price: "$120/session", cat: "Special Ed" },
];
